import { useSelector } from "react-redux";
import { makeGetRequest } from "request";

export const useDashboardData = () => {
    const user = useSelector((state: any) => state.tepngUser.value);
    const TotalAssignedShipment = (startDate: string, endDate: string): Promise<number> => {
        var request: Record<string, any> = {
            what: "getTotalAssignedShipment",
            params: { 
                localClearingAgentId: user?.id,
                startDate: startDate,
                endDate: endDate
            }
        };
        
        return makeGetRequest(request)
            .then((response: any) => { return response.data.totalCount })
            .catch((error:any) => console.log(error) );
    }

    const TotalShipmentDelivered = (startDate: string, endDate: string): Promise<number> => {
        var request: Record<string, any> = {
            what: "getTotalShipmentDelivered",
            params: { 
                localClearingAgentId: user?.id,
                startDate: startDate,
                endDate: endDate
            }
        };
        
        return makeGetRequest(request)
            .then((response: any) => { return response.data.totalCount })
            .catch((error:any) => console.log(error) );
    }

    const NumberOfAssignedAndDeliveredShipment = (month: string, year: number): Promise<number> => {
        var request: Record<string, any> = {
            what: "getNumberOfAssignedAndDeliveredShipment",
            params: { 
                userId: user?.id,
                ...(parseInt(month) > 0 && {month: month}),
                year: year
            }
        };
        
        return makeGetRequest(request)
            .then((response: any) => { return response.data.data })
            .catch((error:any) => console.log(error) );
    }

    const PercentageChangeOfTotalAssignedShipment = (startDate: string, endDate: string): Promise<number> => {
        var request: Record<string, any> = {
            what: "getPercentageChangeOfTotalAssignedShipment",
            params: { 
                startDate: startDate,
                endDate: endDate 
            }
        };
        
        return makeGetRequest(request)
            .then((response: any) => { return response.data.data.percentageChange })
            .catch((error:any) => console.log(error) );
    }

    const PercentageChangeOfTotalShipmentDelivered = (startDate: string, endDate: string): Promise<number> => {
        var request: Record<string, any> = {
            what: "getPercentageChangeOfTotalShipmentDelivered",
            params: { 
                startDate: startDate,
                endDate: endDate 
            }
        };
        
        return makeGetRequest(request)
            .then((response: any) => { return response.data.data.percentageChange })
            .catch((error:any) => console.log(error) );
    }

    return { 
        TotalAssignedShipment, 
        TotalShipmentDelivered, 
        NumberOfAssignedAndDeliveredShipment, 
        PercentageChangeOfTotalAssignedShipment, 
        PercentageChangeOfTotalShipmentDelivered 
    };   
}